import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";

const VANTAGGI = [
  { titolo: "Flessibilità e Accessibilità", desc: "I dipendenti possono seguire la formazione online in qualsiasi momento e da qualsiasi luogo, adattando i corsi al loro programma lavorativo." },
  { titolo: "Costi Ridotti", desc: "Evitare i costi legati alla logistica, come i trasporti e l'organizzazione di eventi in presenza, rende la FAD una soluzione economica." },
  { titolo: "Ampia Offerta di Corsi", desc: "Dalla sicurezza sul lavoro alla gestione aziendale, passando per l'aggiornamento normativo, le soft skills, le lingue e molto altro." },
  { titolo: "Tecnologia Innovativa", desc: "Piattaforme moderne che favoriscono un apprendimento interattivo con materiali multimediali, quiz e forum di discussione." },
  { titolo: "Misurazione dei Progressi", desc: "Le piattaforme permettono di monitorare facilmente i progressi dei dipendenti, registrando risultati degli esami e completamento dei moduli." },
];

const STEPS = [
  { n: "1", titolo: "Consulenza Iniziale", desc: "Consulenza personalizzata per comprendere le esigenze formative e selezionare i corsi FAD più adatti." },
  { n: "2", titolo: "Scelta dei Corsi e Piani Formativi", desc: "Ti aiutiamo a scegliere tra i numerosi corsi online disponibili: gestione aziendale, sicurezza, privacy, aggiornamento normativo e altro." },
  { n: "3", titolo: "Accesso ai Fondi", desc: "Se la tua azienda è iscritta a un fondo interprofessionale, ti guidiamo nell'accesso ai finanziamenti per la FAD." },
  { n: "4", titolo: "Erogazione della Formazione", desc: "I corsi vengono erogati tramite piattaforme online: lezioni, webinar, esercitazioni pratiche e test di valutazione da remoto." },
  { n: "5", titolo: "Monitoraggio e Supporto", desc: "Seguiamo da vicino il progresso della formazione, monitorando la partecipazione e l'efficacia del percorso." },
  { n: "6", titolo: "Rendicontazione e Certificazioni", desc: "Al termine, ci occupiamo della rendicontazione finale e rilasciamo le certificazioni ufficiali." },
];

const BENEFICI = [
  "Risparmio di Tempo e Risorse: nessuna sessione in aula da organizzare",
  "Formazione Continuativa senza allontanarsi dal posto di lavoro",
  "Competitività e Crescita Professionale: dipendenti aggiornati su normative e tecnologie",
  "Semplicità nella Gestione: ci occupiamo di tutti gli aspetti burocratici e organizzativi",
];

export default function FormazioneFADPage() {
  return (
    <main id="main-content" data-testid="formazione-fad-page">
      <section className="relative h-[300px] md:h-[360px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1588072432836-e10032774350?w=1920&q=60&auto=format" alt="Formazione a distanza" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.85)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed'] mb-2">Formazione</span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Formazione a Distanza (FAD)</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-lg text-[var(--confcom-text-primary)] font-semibold font-['Encode_Sans_Semi_Condensed'] leading-relaxed mb-5">
            Apprendimento Flessibile e Accessibile con Promo.Ter e Confcommercio Roma.
          </p>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
            La <strong className="text-[var(--confcom-text-primary)]">Formazione a Distanza (FAD)</strong> rappresenta una soluzione innovativa per le aziende che desiderano aggiornare le competenze del proprio personale in modo flessibile, senza la necessità di spostamenti fisici o interruzioni dell'attività lavorativa. Attraverso Confcommercio Roma e Promo.Ter, con la FAD le aziende possono offrire ai propri dipendenti corsi online <strong className="text-[var(--confcom-text-primary)]">fruibili in qualsiasi momento e da qualsiasi luogo</strong>.
          </p>
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
            La FAD si avvale di piattaforme online per l'erogazione dei corsi, consentendo ai partecipanti di seguire le lezioni in modalità <strong className="text-[var(--confcom-text-primary)]">sincrona (live)</strong> o <strong className="text-[var(--confcom-text-primary)]">asincrona (corsi registrati)</strong>, accedendo a contenuti didattici digitali tramite internet.
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">Vantaggi della Formazione a Distanza</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {VANTAGGI.map((v) => (
              <div key={v.titolo} className="bg-white rounded-xl p-6 border border-[var(--confcom-border)]">
                <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{v.titolo}</h3>
                <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">Come Funziona</h2>
              <div className="space-y-10">
                {STEPS.map((s) => (
                  <div key={s.n} className="flex gap-4">
                    <div className="w-8 h-8 bg-[var(--confcom-blue)] rounded-full flex items-center justify-center shrink-0 text-white font-bold text-sm font-['Encode_Sans_Semi_Condensed']">{s.n}</div>
                    <div>
                      <h3 className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1">{s.titolo}</h3>
                      <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-4">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-[var(--confcom-bg-subtle)] rounded-2xl p-8 border border-[var(--confcom-border)]">
              <h3 className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-5">Benefici Diretti per la Tua Azienda</h3>
              <div className="space-y-3">
                {BENEFICI.map((b) => (
                  <div key={b} className="flex items-start gap-3">
                    <CheckCircle size={18} className="text-[var(--confcom-blue)] shrink-0 mt-0.5" />
                    <span className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{b}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[var(--confcom-blue)] rounded-2xl px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-5">
            <div>
              <p className="text-white font-bold text-xl font-['Encode_Sans_Semi_Condensed'] mb-2">Vuoi attivare subito il tuo percorso formativo? Contattaci!</p>
              <div className="text-white/75 text-sm space-y-1">
                <p>
                  <a href="mailto:commerciale.promoter@confcommercioroma.it" className="hover:text-white transition-colors">commerciale.promoter@confcommercioroma.it</a>
                  {" · "}
                  <a href="mailto:areagestione@confcommercioroma.it" className="hover:text-white transition-colors">areagestione@confcommercioroma.it</a>
                </p>
                <p>
                  <a href="tel:+390668437606" className="hover:text-white transition-colors">0668437 606</a>
                  {" · "}
                  <a href="tel:+390668437530" className="hover:text-white transition-colors">0668437 530</a>
                  {" · "}
                  <a href="tel:+390668437227" className="hover:text-white transition-colors">0668437 227</a>
                </p>
              </div>
            </div>
            <a href="https://forms.gle/98CnoTiUAdGHJ9e88" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-7 py-3 rounded-md font-bold text-sm hover:opacity-90 transition-opacity whitespace-nowrap">
              Richiedi maggiori informazioni <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
